var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 27.5H26.875M3.75 16.25V27.5M26.25 16.25V27.5M9.375 9.99998V27.5M20.625 9.99998V27.5M2.5 16.25H8.75M27.5 16.25H21.25M8.125 9.99998H21.875M15 9.99998V6.22748M15 6.22748V3.71248C15 3.11998 15 2.82373 15.1825 2.63998C15.7575 2.06123 18.125 3.42873 19.025 3.98373C19.785 4.45123 20 5.38623 20 6.22748H15ZM15 27.5V25M13.125 15V15.625M16.875 15V15.625M13.125 20V20.625M16.875 20V20.625",
    stroke: "#B9004A",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L30 7.57143V9.42857H28.1333C28.1333 9.68006 28.0337 9.89769 27.8344 10.0815C27.6351 10.2653 27.3993 10.3571 27.1271 10.3571H4.87292C4.60069 10.3571 4.36493 10.2653 4.16563 10.0815C3.96632 9.89769 3.86667 9.68006 3.86667 9.42857H2V7.57143L16 2ZM5.73333 11.2857H9.46667V22.4286H11.3333V11.2857H15.0667V22.4286H16.9333V11.2857H20.6667V22.4286H22.5333V11.2857H26.2667V22.4286H27.1271C27.3993 22.4286 27.6351 22.5205 27.8344 22.7042C28.0337 22.888 28.1333 23.1057 28.1333 23.3571V24.2857H3.86667V23.3571C3.86667 23.1057 3.96632 22.888 4.16563 22.7042C4.36493 22.5205 4.60069 22.4286 4.87292 22.4286H5.73333V11.2857ZM28.9937 25.2143C29.266 25.2143 29.5017 25.3062 29.701 25.49C29.9003 25.6737 30 25.8914 30 26.1429V28H2V26.1429C2 25.8914 2.09965 25.6737 2.29896 25.49C2.49826 25.3062 2.73403 25.2143 3.00625 25.2143H28.9937Z",
    fill: "#B9004A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaUniversity);
export default __webpack_public_path__ + "static/media/fa_university.0eba00b6fd500420de12c166a12d3ce2.svg";
export { ForwardRef as ReactComponent };